import React from 'react';
import { useState, useEffect } from 'react';
import nexusLogo from '../assets/logo.png'
import {get_apps,userLogout} from '../../../api/api.js';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';


function Headerforprofile() {
  const [userApps, setUserApps] = useState([]);
    const logout = async()=>{
        const response = await userLogout();
        if(response.status===200){
            window.location.href='/'
        }
      }

      const loadHome = async()=>{
        
       
            window.location.href='/landing'
     
      }
      const getuserapps = async () => {
       
        const response = await get_apps();
        if(response.status===200 && response.data.length>0){
            const appnames = response.data.map((item, i) => ({
                key: i,
                label: item.appname,
                value: item.logo,
                url:item.appurl
              }));
            setUserApps(appnames);
        }
    }
    useEffect(()=>{     
        getuserapps();
    },[])
    //const location=useLocation();

    return (
      <Navbar expand="x-lg" className="fixed-navbar">
      <img className='brand' src={nexusLogo} onClick={loadHome} alt="Logo" />
      <h4 className='heading underline`'>Nexus Data Flow Hub</h4>
      <div className='buttondiv'>
      
      
        <Button className="buttonstyle" onClick={logout}><span class="text">Logout</span></Button>
      
      </div>
      

      </Navbar>
    );
  }
  
  export default Headerforprofile;